<template>
  <div class="has-text-left">
    <h5
      class="title"
      :class="{'has-text-right': Language == 'fa' || Language == 'ar','has-text-left': Language != 'fa' && Language != 'ar'}"
    >{{$t("please_enter_amount_withdraw")}}</h5>
    <p class="subtitle">{{$t('bankwire_withdrawal_details_notice')}}</p>

    <div class="field">
      <label
        class="label"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{translations.text.fullName}}</label>
      <p class="control has-icons-left has-icons-right">
        <input
          key="0"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('fullName') }"
          name="fullName"
          type="text"
          :data-vv-as="translations.text.fullName"
          :placeholder="translations.text.fullName"
          v-model="fullName"
        />
        <span
          v-show="errors.has('fullName')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('fullName') }}</span>
        <span
          class="icon is-small"
          :class="{'is-right': Language == 'fa' || Language == 'ar', ' is-left' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-user"></i>
        </span>
        <span
          class="icon is-small"
          :class="{'is-left': Language == 'fa' || Language == 'ar', ' is-right' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-check"></i>
        </span>
      </p>
    </div>

    <div class="field">
      <label
        class="label"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{translations.text.bankName}}</label>
      <p class="control has-icons-left has-icons-right">
        <input
          key="1"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('bankName') }"
          name="bankName"
          type="text"
          :data-vv-as="translations.text.bankName"
          :placeholder="translations.text.bankName"
          v-model="bankName"
        />
        <span
          v-show="errors.has('bankName')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('bankName') }}</span>
        <span
          class="icon is-small"
          :class="{'is-right': Language == 'fa' || Language == 'ar', ' is-left' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-university"></i>
        </span>
        <span
          class="icon is-small"
          :class="{'is-left': Language == 'fa' || Language == 'ar', ' is-right' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-check"></i>
        </span>
      </p>
    </div>

    <div class="field">
      <label
        class="label"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{translations.text.bankAddress}}</label>
      <p class="control has-icons-left has-icons-right">
        <input
          key="2"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('bankAddress') }"
          name="bankAddress"
          type="text"
          :data-vv-as="translations.text.bankAddress"
          :placeholder="translations.text.bankAddress"
          v-model="bankAddress"
        />
        <span
          v-show="errors.has('bankAddress')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('bankAddress') }}</span>
        <span
          class="icon is-small"
          :class="{'is-right': Language == 'fa' || Language == 'ar', ' is-left' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-university"></i>
        </span>
        <span
          class="icon is-small"
          :class="{'is-left': Language == 'fa' || Language == 'ar', ' is-right' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-check"></i>
        </span>
      </p>
    </div>

    <div class="field">
      <label
        class="label"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{translations.text.iBAN}} {{translations.text.orAccount}}</label>
      <p class="control has-icons-left has-icons-right">
        <input
          key="3"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('iBAN') }"
          name="iBAN"
          type="text"
          :data-vv-as="translations.text.iBAN"
          :placeholder="translations.text.iBAN + ' ' + translations.text.orAccount"
          v-model="iBAN"
        />
        <span
          v-show="errors.has('iBAN')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('iBAN') }}</span>
        <span
          class="icon is-small"
          :class="{'is-right': Language == 'fa' || Language == 'ar', ' is-left' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-info"></i>
        </span>
        <span
          class="icon is-small"
          :class="{'is-left': Language == 'fa' || Language == 'ar', ' is-right' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-check"></i>
        </span>
      </p>
    </div>

    <div class="field">
      <label
        class="label"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{translations.text.sortCode}}</label>
      <p class="control has-icons-left has-icons-right">
        <input
          key="3"
          :class="{'input': true, 'is-danger': errors.has('sortCode') }"
          name="sortCode"
          type="text"
          :data-vv-as="translations.text.sortCode"
          :placeholder="translations.text.sortCode"
          v-model="sortCode"
        />
        <span
          v-show="errors.has('sortCode')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('sortCode') }}</span>
        <span
          class="icon is-small"
          :class="{'is-right': Language == 'fa' || Language == 'ar', ' is-left' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-info"></i>
        </span>
        <span
          class="icon is-small"
          :class="{'is-left': Language == 'fa' || Language == 'ar', ' is-right' : Language != 'fa' && Language != 'ar'}"
        >
          <i class="fa fa-check"></i>
        </span>
      </p>
    </div>

    <div class="field columns">
      <div class="column">
        <input
          key="4"
          v-validate="'required'"
          id="bankSwiftYes"
          name="bankHasSwift"
          v-model="bankHasSwift"
          type="radio"
          value="yes"
        />
        <label for="bankSwiftYes">{{$t("my_bank_has_a_swift_code").tTitle()}}</label>
      </div>
      <div class="column">
        <input
          key="5"
          v-validate="'required'"
          name="bankHasSwift"
          id="bankSwiftNo"
          v-model="bankHasSwift"
          type="radio"
          value="no"
        />
        <label for="bankSwiftNo">{{$t("my_bank_does_not_have_a_swift_code").tTitle()}}</label>
      </div>
    </div>
    <span
      v-show="errors.has('bankHasSwift')"
      class="help is-danger"
      :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
    >{{ errors.first('bankHasSwift') }}</span>

    <template v-if="bankHasSwift==='yes'">
      <div class="field">
        <label
          class="label"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{translations.text.swift}}</label>
        <p class="control has-icons-left has-icons-right">
          <input
            key="6"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('swift') }"
            name="swift"
            type="text"
            v-model="swift"
          />
          <span
            v-show="errors.has('swift')"
            class="help is-danger"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{ errors.first('swift') }}</span>
          <span
            class="icon is-small"
            :class="{'is-right': Language == 'fa' || Language == 'ar', ' is-left' : Language != 'fa' && Language != 'ar'}"
          >
            <i class="fa fa-info"></i>
          </span>
          <span
            class="icon is-small"
            :class="{'is-left': Language == 'fa' || Language == 'ar', ' is-right' : Language != 'fa' && Language != 'ar'}"
          >
            <i class="fa fa-check"></i>
          </span>
        </p>
      </div>
    </template>

    <template v-if="bankHasSwift==='no'">
      <p class="is-size-7">{{$t("bank_not_in_swift_network_instructions").tTitle()}}</p>
      <div class="field">
        <label
          class="label"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{$t("correspondent_bank_name").tTitle()}}</label>
        <p class="control has-icons-left has-icons-right">
          <input
            key="7"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('correspondentBankName') }"
            name="correspondentBankName"
            type="text"
            v-model="correspondentBank.name"
          />
          <span
            v-show="errors.has('correspondentBankName')"
            class="help is-danger"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{ errors.first('correspondentBankName') }}</span>
          <span class="icon is-small is-left">
            <i class="fa fa-info"></i>
          </span>
          <span class="icon is-small is-right">
            <i class="fa fa-check"></i>
          </span>
        </p>
      </div>

      <div class="field">
        <label
          class="label"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{$t("correspondent_bank_city").tTitle()}}</label>
        <p class="control has-icons-left has-icons-right">
          <input
            key="8"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('correspondentBankCity') }"
            name="correspondentBankCity"
            type="text"
            v-model="correspondentBank.city"
          />
          <span
            v-show="errors.has('correspondentBankCity')"
            class="help is-danger"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{ errors.first('correspondentBankCity') }}</span>
          <span class="icon is-small is-left">
            <i class="fa fa-info"></i>
          </span>
          <span class="icon is-small is-right">
            <i class="fa fa-check"></i>
          </span>
        </p>
      </div>

      <div class="field">
        <label
          class="label"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{$t("correspondent_bank_swift").tTitle()}}</label>
        <p class="control has-icons-left has-icons-right">
          <input
            key="9"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('correspondentBankSwift') }"
            name="correspondentBankSwift"
            type="text"
            v-model="correspondentBank.swift"
          />
          <span
            v-show="errors.has('correspondentBankSwift')"
            class="help is-danger"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{ errors.first('correspondentBankSwift') }}</span>
          <span class="icon is-small is-left">
            <i class="fa fa-info"></i>
          </span>
          <span class="icon is-small is-right">
            <i class="fa fa-check"></i>
          </span>
        </p>
      </div>
    </template>

    <div
      class="field has-addons amount"
      :class="{'is-pulled-left': Language == 'fa' || Language == 'ar'}"
    >
      <p class="control">
        <a class="button is-static">{{currencySymbols[User.wallet.currency].symbol}}</a>
      </p>
      <p class="control">
        <input
          key="11"
          v-validate="'required|currency'"
          :class="{'input': true, 'is-danger': errors.has('amount') }"
          name="amount"
          type="text"
          :data-vv-as="translations.text.amount"
          :placeholder="translations.text.amount"
          v-model="amount"
        />
        <span
          v-show="errors.has('amount')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('amount') }}</span>
      </p>
      <p class="control">
        <a
          class="button is-success"
          @click="withdraw"
        >
          <span class="icon is-small">
            <i
              class="fa fa-check"
              :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
            ></i>
          </span>
          <span>{{$t("withdraw").tTitle()}}</span>
        </a>
      </p>
    </div>

    <div
      class="modal"
      :class="{'is-active': modalActive}"
    >
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box has-text-left">
          <span v-html="$t('bankwire_notice')"></span>
          <br />
          <br />
          <footer class="modal-foot is-pulled-right">
            <a
              class="button"
              @click="redirectTo('trading-account')"
            >Close</a>
          </footer>
          <div class="is-clearfix"></div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        @click="redirectTo('trading-account')"
      ></button>
    </div>
  </div>
</template>

<script>
import config from '../../../config'
import { service } from '../../../app'
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      conversionRate: 1,
      modalActive: false,
      amount: null,
      fullName: '',
      bankName: '',
      bankAddress: '',
      currency: '',
      iBAN: '',
      sortCode: '',
      swift: '',
      bankHasSwift: '',
      correspondentBank: {
        name: '',
        city: '',
        swift: '',
      },
      translations: {
        text: {
          amount: this.$t('amount').tTitle(),
          bankName: this.$t('bank_name').tTitle(),
          bankAddress: this.$t('bank_address').tTitle(),
          currency: this.$t('currency'),
          fullName: this.$t('full_name').tTitle(),
          iBAN: 'IBAN',
          orAccount: this.$t('or_account_no_for_uk'),
          sortCode: this.$t('sort_code'),
          swift: 'Swift',
        },
      },
      currencySymbols: config.currencies,
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    this.currency = this.User.wallet.currency
    // if (this.User.wallet.currency.toUpperCase() !== 'EUR') {
    // 	// get currency conversion rate
    // 	this.getCurrencyConversionRate('eur')
    // }
  },
  methods: {
    getCurrencyConversionRate(targetCurrency) {
      service.get('/finance/rates/' + this.User.wallet.currency + '/' + targetCurrency).then(response => {
        if (response.data) {
          this.conversionRate = response.data.rate
        }
      })
    },
    redirectTo(location) {
      this.$router.push('/' + (this.Language || 'en') + '/' + location)
    },
    withdraw() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$bus.$emit(
            'RequestWithdraw',
            '/finance/withdraw/bankwire',
            {
              bankName: this.bankName,
              bankAddress: this.bankAddress,
              // currency:this.currency,
              currency: this.User.wallet.currency, // temp
              // currency: 'EUR',
              fullName: this.fullName,
              iBAN: this.iBAN,
              sortCode: this.sortCode,
              swift: this.swift,
              correspondentBankName: this.correspondentBank.name,
              correspondentBankCity: this.correspondentBank.city,
              correspondentBankSwift: this.correspondentBank.swift,
              amount: String(this.amount),
              userID: this.$store.state.user.info.ID,
              gateway: 'bankwire',
            },
            response => {
              this['logoLoader/set'](false)
              this.modalActive = true
            },
            () => {
              this['logoLoader/set'](false)
            }
          )
        }
      })
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>

<style lang="scss" scoped>
label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// BankWire.vue?b390b440